import * as Tabs from "@radix-ui/react-tabs";

import { cn } from "../lib/utils";

export function IndustryTabs({
  tabs,
  className,
}) {
  const defaultValue = tabs[0]?.key;

  return (
    <Tabs.Root defaultValue={defaultValue} className={cn("space-y-6", className)}>
      <Tabs.List className="flex flex-wrap gap-2">
        {tabs.map((t) => (
          <Tabs.Trigger
            key={t.key}
            value={t.key}
            className="focus-ring rounded-full border border-border-subtle bg-white/5 px-4 py-2 text-sm font-semibold text-text-secondary data-[state=active]:bg-white/10 data-[state=active]:text-text-primary"
          >
            {t.title}
          </Tabs.Trigger>
        ))}
      </Tabs.List>

      {tabs.map((t) => (
        <Tabs.Content key={t.key} value={t.key} className="glass-card p-6">
          <div className="grid gap-6 lg:grid-cols-2">
            <div className="space-y-3">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                Frameworks
              </div>
              <div className="text-sm font-semibold text-text-primary">{t.frameworks}</div>

              <div className="mt-4 text-xs font-semibold uppercase tracking-wide text-text-muted">
                Focus Areas
              </div>
              <div className="mt-2 grid gap-2 sm:grid-cols-2">
                {t.focusAreas.map((a) => (
                  <div
                    key={a}
                    className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary"
                  >
                    {a}
                  </div>
                ))}
              </div>
            </div>

            <div className="space-y-3">
              <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
                Case Study
              </div>
              <div className="text-lg font-semibold text-text-primary">{t.caseStudy}</div>
              <a
                href={t.ctaHref}
                className="focus-ring inline-flex h-11 items-center justify-center rounded-xl bg-white/5 px-4 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
              >
                {t.ctaLabel} →
              </a>
            </div>
          </div>
        </Tabs.Content>
      ))}
    </Tabs.Root>
  );
}
